import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import moneyHelper from '../Helpers/moneyHelper';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import Comments from '../Elements/Comments';
import FaIcon from '../Elements/FaIcon';
import LogComponent from '../Elements/LogComponent';
import LineItemTypeEnum from '../Enums/LineItemTypeEnum';
import FeeTypesEnum from '../Enums/FeeTypesEnum';
import FreelancerFeeHelper from '../Helpers/ModelHelpers/FreelancerFeeHelper';

class FreelancerLineItemInView {
  constructor(item) {
    this.initialize(item);
  }

  async initialize(item) {
    this.FreelancerLineItemId = item.freelancerLineItemId;
    this.FreelancerUserId = item.freelancerUserId;
    this.FeeType = item.feeType;
    this.LineItemType = item.lineItemType;
    this.ClientId = item.clientId;
    this.SurveyId = item.surveyId;
    this.TpSurveyId = item.tpSurveyId;
    this.ThirdPartySource = item.thirdPartySource;
    this.WaveId = item.waveId;
    this.TpWaveId = item.tpWaveId;
    this.ApplyDate = item.applyDate;
    this.Fee = item.fee;
    this.ClientName = item.clientName;
    this.ClientSassieId = item.clientSassieId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.FreelancerUserName = item.freelancerUserName;
    this.FreelancerUserCurrencyCode = item.freelancerUserCurrencyCode;
    this.FreelancerUserOfficeName = item.freelancerUserOfficeName;
    this.SurveyName = item.surveyName;
    this.SurveySassieId = item.surveySassieId;
    this.TpSurveyThirdPartySurveyName = item.tpSurveyThirdPartySurveyName;
    this.TpSurveyThirdPartySurveyId = item.tpSurveyThirdPartySurveyId;
    this.WaveName = item.waveName;
    this.WaveSasseId = item.waveSasseId;
    this.TpWaveThirdPartyWaveName = item.tpWaveThirdPartyWaveName;
    this.TpWaveThirdPartyWaveId = item.tpWaveThirdPartyWaveId;
    this.FreelancerUserIsKAM = item.freelancerUserIsKAM;
    this.FreelancerUserIsRM = item.freelancerUserIsRM;
    this.FreelancerUserIsDQ = item.freelancerUserIsDQ;
    this.FreelancerUserIsBD = item.freelancerUserIsBD;
    this.FreelancerUserIsBI = item.freelancerUserIsBI;
    this.FreelancerUserIsHR = item.freelancerUserIsHR;
    this.FreelancerUserIsIT = item.freelancerUserIsIT;
    this.FreelancerUserIsMarketing = item.freelancerUserIsMarketing;
    this.FreelancerUserIsFinance = item.freelancerUserIsFinance;
    this.IsActive = item.isActive;
    this.TimesheetEntryId = item.timesheetEntryId;
    this.TimesheetEntryStartDate = item.timesheetEntryStartDate;
    this.TimesheetEntryEndDate = item.timesheetEntryEndDate;
    this.TimesheetEntryStartTime = item.timesheetEntryStartTime;
    this.TimesheetEntryEndTime = item.timesheetEntryEndTime;
    this.LastComment = item.lastComment;
    this.FreelancerInvoiceId = item.freelancerInvoiceId;
    this.Status = item.status;
    this.TimesheetEntryLength = item.timesheetEntryLength;
    this.LoggedTime = item.loggedTime;
    this.Occurence = item.occurence;
    this.Selected = false;
    this.TimesheetClientNameAndId = item.timesheetClientNameAndId;
    this.TimesheetOppNameAndId = item.timesheetOppNameAndId;
    this.TimesheetLeadNameAndId = item.timesheetLeadNameAndId;
    FreelancerLineItemInView.ConvertEntryDatesToLocal(this);
  }

  static ConvertEntryDatesToLocal(item) {
    if (!item.TimesheetEntryId) return;
    const localUTCOffsetInMinutes = new Date().getTimezoneOffset();

    // Combine startdate and time to one date object (date.month is zero based so we need to subtrack 1)
    let combinedStartDate = new Date(
      item.TimesheetEntryStartDate.split('-')[0],
      item.TimesheetEntryStartDate.split('-')[1] - 1,
      item.TimesheetEntryStartDate.split('-')[2],
      item.TimesheetEntryStartTime.split(':')[0],
      item.TimesheetEntryStartTime.split(':')[1],
      0,
      0
    );

    combinedStartDate = this.dateAdd(combinedStartDate, 'minute', -1 * localUTCOffsetInMinutes);

    item.TimesheetEntryStartDate = dateTimeHelper.getFormattedDate(combinedStartDate, '-');
    item.TimesheetEntryStartTime = (
      combinedStartDate.getHours().toString().length === 1
        ? '0'.concat(combinedStartDate.getHours())
        : combinedStartDate.getHours()
    )
      .toString()
      .concat(
        `:${
          combinedStartDate.getMinutes().toString().length === 1
            ? '0'.concat(combinedStartDate.getMinutes())
            : combinedStartDate.getMinutes()
        }`
      );

    let combinedEndDate = new Date(
      item.TimesheetEntryEndDate.split('-')[0],
      item.TimesheetEntryEndDate.split('-')[1] - 1,
      item.TimesheetEntryEndDate.split('-')[2],
      item.TimesheetEntryEndTime.split(':')[0],
      item.TimesheetEntryEndTime.split(':')[1],
      0,
      0
    );

    combinedEndDate = this.dateAdd(combinedEndDate, 'minute', -1 * localUTCOffsetInMinutes);

    item.endDate = dateTimeHelper.getFormattedDate(combinedEndDate, '-');
    item.TimesheetEntryEndTime = (
      combinedEndDate.getHours().toString().length === 1
        ? '0'.concat(combinedEndDate.getHours())
        : combinedEndDate.getHours()
    )
      .toString()
      .concat(
        `:${
          combinedEndDate.getMinutes().toString().length === 1
            ? '0'.concat(combinedEndDate.getMinutes())
            : combinedEndDate.getMinutes()
        }`
      );

    return item;
  }

  static dateAdd(date, interval, units) {
    if (!(date instanceof Date)) return undefined;
    let ret = new Date(date); //don't change original date
    const checkRollover = () => {
      if (ret.getDate() !== date.getDate()) ret.setDate(0);
    };
    switch (String(interval).toLowerCase()) {
      case 'year':
        ret.setFullYear(ret.getFullYear() + units);
        checkRollover();
        break;
      case 'quarter':
        ret.setMonth(ret.getMonth() + 3 * units);
        checkRollover();
        break;
      case 'month':
        ret.setMonth(ret.getMonth() + units);
        checkRollover();
        break;
      case 'week':
        ret.setDate(ret.getDate() + 7 * units);
        break;
      case 'day':
        ret.setDate(ret.getDate() + units);
        break;
      case 'hour':
        ret.setTime(ret.getTime() + units * 3600000);
        break;
      case 'minute':
        ret.setTime(ret.getTime() + units * 60000);
        break;
      case 'second':
        ret.setTime(ret.getTime() + units * 1000);
        break;
      default:
        ret = undefined;
        break;
    }
    return ret;
  }

  static NameOfTheIdField() {
    return 'FreelancerLineItemId';
  }
  static nameOfTheItemDetailList() {
    return 'Vendor Line Items';
  }

  static MoneyFields = ['Fee'];

  static Currency() {
    return 'FreelancerUserCurrencyCode';
  }

  static MoneyFieldsSecondary = [''];

  static CurrencySecondary() {
    return 'FreelancerUserCurrencyCode';
  }

  static DateFields = ['ApplyDate'];

  static BoolFields = ['FreelancerUserIsKAM', 'FreelancerUserIsRM', 'FreelancerUserIsDQ'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'FeeType', label: 'Fee Type', className: 'text-left' },
        { name: 'LineItemType', label: 'Line Item Type', className: 'text-left' },
        { name: 'ApplyDate', label: 'Application Date' },
        { name: FreelancerLineItemInView.getClientName, label: 'Client (Bravo ID)', className: 'text-left' },
        { name: FreelancerLineItemInView.getSurveyName, label: 'Survey (ID)', className: 'text-left' },
        { name: FreelancerLineItemInView.getWaveName, label: 'Wave (ID)', className: 'text-left' },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
          label: 'Fee',
          className: 'text-right',
        },
        { name: 'ThirdPartySource', label: 'Third Party Source', className: 'text-left' },
        { name: FreelancerLineItemInView.getTpSurveyName, label: 'TP Survey (ID)', className: 'text-left' },
        // { name: FreelancerLineItemInView.getTpWaveName, label: 'TP Wave (ID)', className: 'text-left' },
        { name: 'FreelancerInvoiceId', label: 'Freelancer Invoice Id' },
      ],
    },
    {
      tabName: 'RelatedTimesheetEntry',
      tabLabel: 'Related Activity Tracker Entry',
      icon: 'fa-solid fa-calendar-days',
      data: [
        { name: 'TimesheetEntryId', label: 'Activity Tracker Entry Id' },
        {},
        {},
        { name: 'TimesheetEntryLength', label: 'Activity Tracker Entry Length Total (hour)' },
        { name: 'Occurence', label: 'Activity Tracker Entry Length (days)' },
        {},
        { name: 'TimesheetEntryStartDate', label: 'Start Date' },
        { name: 'TimesheetEntryStartTime', label: 'Start Time' },
        {},
        { name: 'TimesheetEntryEndDate', label: 'End Date' },
        { name: 'TimesheetEntryEndTime', label: 'End Time' },
        {},
        { name: 'TimesheetClientNameAndId', label: 'Client' },
        { name: 'TimesheetOppNameAndId', label: 'Opportunity' },
        { name: 'TimesheetLeadNameAndId', label: 'Lead' },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      data: [
        {
          name: FreelancerLineItemInView.getCommentsContent,
          label: 'Comments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: FreelancerLineItemInView.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={10007}
        entityId={item.FreelancerLineItemId}
      />
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='FreelancerLineItem'
        entityId={item.FreelancerLineItemId}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Id',
        orderById: 'FreelancerLineItemId',
        data: 'FreelancerLineItemId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 20,
      },
      { label: 'Client (Bravo ID)', orderById: 'ClientName', data: FreelancerLineItemInView.getClientName },
      { label: 'Survey (ID)', orderById: 'SurveyName', data: FreelancerLineItemInView.getSurveyName },
      {
        label: 'TP Survey (ID)',
        orderById: 'TpSurveyId',
        data: 'TpSurveyThirdPartySurveyName',
      },
      {
        label: 'Third Party Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
      },
      {
        label: 'Fee',
        orderById: 'Fee',
        data: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
        minWidth: 40,
      },
      {
        label: 'Additional Info',
        orderById: 'FeeType',
        data: FreelancerLineItemInView.getFeeTypeCellContent,
        minWidth: 20,
      },
    ];
  }

  static getFeeTypeCellContent(item) {
    return (
      <div
        className={
          item.FeeType === FeeTypesEnum.Resource
            ? 'text-success'
            : item.FeeType === FeeTypesEnum.DataQuality
            ? 'text-danger'
            : 'text-primary'
        }
      >
        <FaIcon
          iconName={FreelancerFeeHelper.GetFeeTypeIcon(item.FeeType)}
          tooltipText={item.FeeType}
        />{' '}
        {item.LineItemType === LineItemTypeEnum.Deduction ? (
          <FaIcon
            iconName='fa-solid fa-minus-square'
            className='text-danger'
            tooltipText='Deduction'
          />
        ) : (
          <FaIcon
            iconName='fa-solid fa-plus-square'
            tooltipText='Addition'
            className='text-success'
          />
        )}{' '}
        {item.TimesheetEntryId > 0 ? (
          <FaIcon
            iconName='fa-solid fa-history'
            className='Addition'
            tooltipText='Activity Tracker Entry'
          />
        ) : (
          ''
        )}
      </div>
    );
  }

  static getClientName(item) {
    return `${item.ClientName} (${item.ClientId})`;
  }

  static getSurveyName(item) {
    if (item.SurveySassieId === '' || item.SurveySassieId === undefined || item.SurveySassieId === null) return '';

    return `${item.SurveyName} (${item.SurveySassieId})`;
  }

  static getWaveName(item) {
    if (item.WaveSasseId === '' || item.WaveSasseId === undefined || item.WaveSasseId === null) return '';

    return `${item.WaveName} (${item.WaveSasseId})`;
  }

  static getTpSurveyName(item) {
    if (
      item.TpSurveyThirdPartySurveyId === '' ||
      item.TpSurveyThirdPartySurveyId === undefined ||
      item.TpSurveyThirdPartySurveyId === null
    )
      return '';
    return `${item.TpSurveyThirdPartySurveyName} (${item.TpSurveyThirdPartySurveyId})`;
  }

  static getTpWaveName(item) {
    if (
      item.TpWaveThirdPartyWaveIdId === '' ||
      item.TpWaveThirdPartyWaveIdId === undefined ||
      item.TpWaveThirdPartyWaveIdId === null
    )
      return '';
    return `${item.TpWaveThirdPartyWaveName} (${item.TpWaveThirdPartyWaveId})`;
  }
}

export default FreelancerLineItemInView;
